import { Button, ButtonGroup, ButtonVariant, Collapse } from "@blueprintjs/core";
import { MouseEvent, useState } from "react";
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars";
import { ColorPicker } from "src/libs/useful";
import { __ } from "src/libs/utilities";
import { ALIGN, ALIGN_DATA, FONT_SIZES_NAMES, ILanding } from "src/modules/pe-landing-module/data/interfaces";
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store";

/* Protopia Ecosystem component */
export interface ITextEditorToolsProps {
   onChange: () => void
}
const TextEditorTools = (props: ITextEditorToolsProps): JSX.Element => {
    const currentLanding: ILanding = useLandingStore((state:ILandingStore) => state.currentLanding)
    const [isOpenColor, setIsOpenColor] = useState<boolean>(false)
    const [isOpenFill, setIsOpenFill] = useState<boolean>(false)
    const [isOpenFont, setIsOpenFont] = useState<boolean>(false)
    const [isOpenFontSize, setIsOpenFontSize] = useState<boolean>(false)
    const [isOpenAlign, setIsOpenAlign] = useState<boolean>(false)
    const [isOpenImage, setIsOpenImage] = useState<boolean>(false)
    const [color, setColor] = useState<string>("#FFFFFF")
    const [fill, setFill] = useState<string>("#d2e61fff") 
    const [font, setFont] = useState<string>("") 
    const [fontSize, setFontSize] = useState<number>(12) 
    const [align, setAlign] = useState<ALIGN>(ALIGN.START) 
    const [image, setImage] = useState<string>("") 
    
    const closeAllCollapses = () => {
        setIsOpenFill(false)
        setIsOpenColor(false)
        setIsOpenFont(false)
        setIsOpenFontSize(false)
        setIsOpenAlign(false)
        setIsOpenImage(false)
    }
    const onCommand = (evt: any, command: string, args: string | undefined = undefined) => {
        document.execCommand(command, false, args)
        closeAllCollapses()
        if(!!evt) {
            evt.preventDefault()
            evt.stopPropagation()
        }
        onChange()
	    return false
    }
    const onFill = (color: string, evt: any) => {  
        setFill(color)
        document.execCommand('styleWithCSS', false, true)
        document.execCommand('hiliteColor', false, color)
        document.execCommand('styleWithCSS', false, false)
        onChange()
    }
    const onColor = (color: string, evt: any) => {  
        setColor(color)
        document.execCommand('styleWithCSS', false, true)
        document.execCommand('foreColor', false, color)
        document.execCommand('styleWithCSS', false, false) 
        onChange()
    }
    const onFont = (_font: string ) => {  
        setFont(_font)
        document.execCommand('styleWithCSS', false, true)
        document.execCommand('fontName', false, _font)
        document.execCommand('styleWithCSS', false, false) 
        onChange()
    }
    const onFontSize = (size: keyof typeof FONT_SIZES_NAMES ) => {   
        document.execCommand('styleWithCSS', false, true)
        document.execCommand('fontSize', false,  `${Object.keys(FONT_SIZES_NAMES).findIndex(key => key === size) + 1}` )
        document.execCommand('styleWithCSS', false, false) 
        onChange()
    }
    const onAlign = (size: keyof typeof ALIGN_DATA ) => {
        console.log(ALIGN_DATA[size].command, size) 
        setAlign(size)   
        document.execCommand(  `${ ALIGN_DATA[size].command }` ) 
        onChange()
    }
    const onImage = (evt: any ) => { 
        const image = evt.target.value
        setImage(image)
        console.log(image)
        document.execCommand( "insertImage", false, image  ) 
        onChange()
        evt.preventDefault()
        evt.stopPropagation()
    }
    const onChange = () => {
        setTimeout(props.onChange, 200 )
    }
    
    console.log("PAGE")
    
    return <div className='pe-text-editor-tools-container'>
        <Collapse isOpen={isOpenFill} className="w-100">
            <div className="container p-3">
                <ColorPicker color={ fill } onChoose={onFill} />
            </div>
        </Collapse>
        <Collapse isOpen={isOpenColor} className="w-100">
            <div className="container p-3">
                <ColorPicker color={ color } onChoose={onColor} />
            </div>
        </Collapse>
        <Collapse isOpen={isOpenFont} className="w-100">
            <ButtonGroup variant={ButtonVariant.MINIMAL} fill vertical className="container py-4">
                {
                    currentLanding.fonts.map(font => {
                        return <Button key={font} onClick={() => onFont(font)}>{ font }</Button>
                    })
                }
            </ButtonGroup>
        </Collapse>
        <Collapse isOpen={isOpenFontSize} className="w-100">
            <ButtonGroup variant={ButtonVariant.MINIMAL} fill className="container py-4">
                {
                    (Object.keys(FONT_SIZES_NAMES) as (keyof typeof FONT_SIZES_NAMES)[]).map((sz: keyof typeof FONT_SIZES_NAMES) => {
                        return <Button key={sz} onClick={() => onFontSize(sz)}>
                            { __( FONT_SIZES_NAMES[sz] ) }
                        </Button>
                    })
                }
            </ButtonGroup>
        </Collapse>
        <Collapse isOpen={isOpenImage} className="w-100">
            <div className="container py-4" onClick={(evt: MouseEvent) => {
                
            }}>
                <input 
                    type="text" 
                    placeholder={__("set image url")} 
                    onChange={ onImage } 
                    onClick={(evt: any) => {
                        evt.preventDefault()
                        evt.stopPropagation()
                    }}
                    className="form-control input dark"
                />
            </div>
        </Collapse>
        <Collapse isOpen={isOpenAlign} className="w-100">
            <ButtonGroup variant={ButtonVariant.MINIMAL} fill className="container py-4">
                {
                    (Object.keys(ALIGN_DATA) as (keyof typeof ALIGN_DATA)[]).map((sz: keyof typeof ALIGN_DATA) => {
                        return <Button 
                            key={sz} 
                            onClick={(evt) => onAlign( sz )} 
                            icon={ALIGN_DATA[sz].icon as any}
                        >
                            { __( ALIGN_DATA[sz].title ) }
                        </Button>
                    })
                }
            </ButtonGroup>
        </Collapse>
        <div>
            <Button icon="bold" variant={ButtonVariant.MINIMAL} title={__("Bold")} onClick={(evt) => onCommand(evt, "bold")} />
            <Button icon="italic" variant={ButtonVariant.MINIMAL} title={__("Italic")} onClick={(evt) => onCommand(evt, "italic")} />
            <Button icon="underline" variant={ButtonVariant.MINIMAL} title={__("Underline")} onClick={(evt) => onCommand(evt, "underline")} />
            <Button icon="tint" variant={ButtonVariant.MINIMAL} title={__("Text color")} onClick={() => { 
                closeAllCollapses()
                setIsOpenColor( true ) 
            }} />
            <Button icon="highlight" variant={ButtonVariant.MINIMAL} title={__("Fill color")} onClick={() => { 
                closeAllCollapses()
                setIsOpenFill( true ) 
            }} /> 
            <Button icon="font" variant={ButtonVariant.MINIMAL} title={__("Font")}  onClick={() => { 
                closeAllCollapses()
                setIsOpenFont( true )
            }} />
            <Button variant={ButtonVariant.MINIMAL} title={__("Font size")}  onClick={() => { 
                closeAllCollapses()
                setIsOpenFontSize( true )
            }}>
                <i className="fas fa-text-height"></i>
            </Button>
            <Button icon={ ALIGN_DATA[align].icon as any } variant={ButtonVariant.MINIMAL} title={__( "Align" )} onClick={() => { 
                closeAllCollapses()
                setIsOpenAlign( true )
            }} />
            <Button icon="paragraph" variant={ButtonVariant.MINIMAL} title={__("Paragraph")} onClick={(evt) => onCommand(evt, "formatBlock", "p")} /> 
            <Button icon="citation" variant={ButtonVariant.MINIMAL} title={__("Quote")} onClick={(evt) => onCommand(evt, "formatBlock", "blockquote")} /> 
        
            <Button icon="subscript" variant={ButtonVariant.MINIMAL} title={__("Subscript")} onClick={(evt) => onCommand(evt, "subscript")} /> 
            <Button icon="superscript" variant={ButtonVariant.MINIMAL} title={__("Superscript")} onClick={(evt) => onCommand(evt, "superscript")} /> 
            <Button icon="link" variant={ButtonVariant.MINIMAL} title={__("Link")} /> 
            <Button icon="unlink" variant={ButtonVariant.MINIMAL} title={__("Unlink")} onClick={(evt) => onCommand(evt, "unlink")} /> 
            <Button icon="properties" variant={ButtonVariant.MINIMAL} title={__("List")}  onClick={(evt) => onCommand(evt, "insertUnorderedList")} /> 
            <Button icon="numbered-list" variant={ButtonVariant.MINIMAL} title={__("Numbered list")} onClick={(evt) => onCommand(evt, "insertOrderedList")} /> 
            <Button icon="media" variant={ButtonVariant.MINIMAL} title={__("Image")} onClick={() => { 
                closeAllCollapses()
                // setIsOpenImage( true )
                var url = prompt( __("set image url"), '' );
                if(!!url) {
                    document.execCommand('insertImage', false, url);
                } 
            }} /> 
            <Button icon="more" variant={ButtonVariant.MINIMAL} title={__("More")} /> 
            <Button icon="cross" variant={ButtonVariant.MINIMAL} title={__("Reset style")} onClick={(evt) => onCommand(evt, "removeFormat")} />

        </div> 
    </div>
}
export default TextEditorTools